export default __webpack_public_path__ + "static/Museos-Interactivos-en-Mexico3Exp3-dd7b99be59bbbe605913e919ee7d5621.jpg";